export default "__VITE_ASSET___Iydi5NR__"